// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getSalesAgentListApi = (params = {}) =>
  DataService.get(`/sales-agents${Object.keys(params).length ? `?${getQueryString(params)}` : ''}`);

export const createSalesAgentApi = (data) => DataService.post('/sales-agents', data);

export const getSalesAgentDetailApi = (salesAgentId) => DataService.get(`/sales-agent/${salesAgentId}`);

export const updateSalesAgentStatusApi = (salesAgentId, status) =>
  DataService.put(`/sales-agent/${salesAgentId}/status`, { status });

export const updateSalesAgentApi = (salesAgentId, data) => DataService.put(`/sales-agent/${salesAgentId}`, data);

export const getSalesAgentMerchantsApi = (salesAgentId, params = {}) =>
  DataService.get(
    `/sales-agent/${salesAgentId}/merchants${Object.keys(params).length ? `?${getQueryString(params)}` : ''}`,
  );

/** Multipart FormData: first_name, last_name, optional profile_image */
export const updateSalesAgentMeApi = (formData) => DataService.post('sales-agent/me', formData);

/** Logged-in sales agent: own merchants list (pagination, optional search). */
export const getSalesAgentMyMerchantsListApi = (params = {}) => {
  const q = getQueryString(params);
  return DataService.get(q ? `sales-agent/merchants?${q}` : 'sales-agent/merchants');
};

/** Logged-in sales agent: single merchant detail by id. */
export const getSalesAgentMerchantByIdApi = (merchantId) =>
  DataService.get(`sales-agent/merchant/${merchantId}`);
